import React, { createContext, useContext, useState, useEffect } from "react";

const DropdownContext = createContext<any>({});

export const useDropdownContext = () => useContext(DropdownContext);

export const DropdownProvider = ({ children, defaultSelectedItem, open }) => {
    const [selectedItem, setSelectedItem] = useState(null);

    // Adding selected item to provider's object
    useEffect(() => {
        setSelectedItem(defaultSelectedItem);
    }, [defaultSelectedItem.eventKey, defaultSelectedItem.text, defaultSelectedItem.html]);

    return (
        <DropdownContext.Provider value={{defaultSelectedItem, selectedItem, setSelectedItem, open}}>
            {children}
        </DropdownContext.Provider>
    );
}
